import React from "react";
import "./Video.scss";

function Video(props) {
  return (
    <div className="video_wrapper">
      <video autoPlay loop muted playsInline>
        <source src={props.src} type="video/mp4" />
      </video>
    </div>
  );
}

Video.propTypes = {};
Video.defaultProps = {};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Common/Video/Video.jsx